import { Pipe, PipeTransform } from "@angular/core";
import { LocaleService } from "./locale.service";

@Pipe({
  name: "t",
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(
    key: string | null | undefined,
    params?: Record<string, string | number | null | undefined>,
  ): string {
    if (!key) {
      return "";
    }

    return this.localeService.t(key, params);
  }
}
